<template>
  <MasterHeader />
  <LocalNav :list="state.localNav" />
  <div class="u-containar responsive">
    <div id="question">
      <HeadingLv3 text="今日の問題" />
      <h3 class="question_title" v-html="testState.test.question" />
      <p class="question_level">
        <span>難易度</span>
        <Rate :level="testState.test.level" />
      </p>
      <div class="questionHeader_data">
        <p class="questionHeader_category">
          {{ testState.test.category.label }}
        </p>
        <p class="questionHeader_tag">
          <span v-for="section in testState.test.sections" :key="section">
            {{ section }}
          </span>
        </p>
        <p class="questionHeader_date">{{ testState.test.date }}</p>
      </div>
      <MasterAnswer
        v-if="state.selectedAnswer"
        :answers="testState.test.answers"
        :answer="state.selectedAnswer"
        :commentary="testState.test.commentary"
        :images="testState.test.answerImages"
      />
      <MasterQuestion
        v-else
        :answers="testState.test.answers"
        :images="testState.test.questionImages"
        :question-id="testState.test.id"
        :question-type="Number(testState.test.category.value)"
        @submit="receiveAnswer"
      />
    </div>
    <MasterFooter :ignoreId="testState.test.id" />
  </div>
</template>

<script lang="ts">
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Rate from '@/components/elements/Rate.vue'
import LocalNav from '@/components/block/LocalNav.vue'
import MasterQuestion from '@/components/block/MasterQuestion.vue'
import MasterAnswer from '@/components/block/MasterAnswer.vue'
import MasterHeader from '@/components/block/MasterHeader.vue'
import MasterFooter from '@/components/block/MasterFooter.vue'
import { reactive, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useTest } from '@/provider/test'

export default defineComponent({
  name: 'Master',
  components: {
    HeadingLv3,
    Rate,
    LocalNav,
    MasterQuestion,
    MasterAnswer,
    MasterHeader,
    MasterFooter
  },
  setup() {
    const state = reactive<any>({
      selectedAnswer: null,
      localNav: [
        { id: 'question', label: '問題' },
        // { id: 'result', label: '成績' },
        { id: 'backnumber', label: 'バックナンバー' }
      ]
    })
    const { state: testState, getTest, getTests } = useTest()
    const route = useRoute()
    const getData = () => {
      const id = Number(route.params.id)
      state.localNav[0].label = id ? '問題' : '今日の問題'
      state.selectedAnswer = null
      if (id) getTest({ id })
      else getTests({ limit: 1 })
    }
    const receiveAnswer = (answer: any) => {
      state.selectedAnswer = answer
      location.href = '#answer'
    }

    watch(() => route.path, getData, { immediate: true })
    return {
      state,
      testState,
      receiveAnswer
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables'as var;

.responsive {
  margin-top: 50px;
  @include mixins.media() {
    display: grid;
    grid-template-columns: 1fr 336px;
    gap: 30px;
  }
}
.question_title {
  margin-top: 22px;
  font-weight: 500;
  font-size: 1.8rem;
  letter-spacing: 0.03em;
  line-height: 1.7;
}
.question_level {
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  > span:first-child {
    margin-right: 5px;
  }
  @include mixins.media() {
    font-size: 1.8rem;
    margin-top: 20px;
  }
}
.questionHeader_data {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2px;
  line-height: 1;
  margin-bottom: 20px;
  @include mixins.media() {
    margin-bottom: 40px;
  }
}
.questionHeader_category {
  margin-right: 6px;
  padding: 4px 5px;
  font-size: 1rem;
  background-color: #3069ea;
  color: #fff;
}
.questionHeader_tag {
  margin-right: 10px;
}
#question {
  margin-bottom: 40px;
}
</style>
